import React from 'react';
import { Users, BookOpen, Star, Map } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="text-accent" size={24} data-id="element-264" />,
    text: '+500 nutris clínicos confían'
  }, {
    icon: <BookOpen className="text-accent" size={24} data-id="element-265" />,
    text: '6 Tomos Clínicos + Bonos'
  }, {
    icon: <Star className="text-accent" size={24} data-id="element-266" />,
    text: '4.9/5 calificación ⭐'
  }, {
    icon: <Map className="text-accent" size={24} data-id="element-267" />,
    text: '🇦🇷 Todo el país'
  }];
  return <div className="text-white py-4 border-y border-accent/10" data-id="element-268">
      <div className="max-w-6xl mx-auto px-3" data-id="element-269">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x-0 md:divide-x divide-accent/20" data-id="element-270">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center gap-1" data-id="element-271">
              {stat.icon}
              <span className="font-semibold text-xs md:text-sm" data-id="element-272">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}